/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Edit_Tag_LabelInputs */



/**
* | output |
* | --- |
* | "Edit Tag" |
*
* @param {Tags_Manager_Edit_Tag_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_edit_tag_label = /** @type {((inputs?: Tags_Manager_Edit_Tag_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Edit_Tag_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le tag")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать тег")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar etiqueta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグを編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar etiqueta")
	return /** @type {LocalizedString} */ ("Edit Tag")
});